<template>
  <div style="width: 100%" :style="'height:'+ (this.$store.state.windowHeight - 150) +'px'" @click="handlePageClick">
    <el-space wrap>
      <el-input v-model="obj.searchValue" placeholder="名称/代码 搜索主力合约" @input="handleInput" clearable @keyup.enter="handleEnter" style="width: 250px;">
        <template #prefix>
          <el-icon class="el-input__icon"><search /></el-icon>
        </template>
      </el-input>
      <el-select v-model="obj.selectedRangeValue" @change="handleSelectChange" style="width:110px">
        <el-option
          v-for="item in obj.selectRangeList"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-button type="primary" @click="handleRefresh">
        <el-icon class="el-input__icon"><refresh /></el-icon>
      </el-button>
    </el-space>
    <div style="width: 250px; max-height: 420px;" class='search-ul'>
      <div v-for="data in obj.filteredList" :key="data" class="search-li" @click="handleClick(data)">
        {{data['name']}} {{data['symbol']}} {{data['exchange']}}
        <span v-if="data['main'] === 1"> *主力 </span>
      </div>
    </div>
    <div id="chart" style="width: 100%" :style="'height:'+ (this.$store.state.windowHeight - 400) +'px'" ref="chartDomRef" ></div>
  </div>
</template>
<script>
import { getCurrentInstance, onMounted, onUnmounted, reactive, ref, nextTick } from 'vue'
import { useStore } from 'vuex'
import { useRoute, useRouter } from 'vue-router'
import { http } from '../util/http'
import { setCharts } from '../module/line'
export default {
  setup () {
    const vueEvent = getCurrentInstance()?.appContext.config.globalProperties.vueEvent
    const route = useRoute()
    const router = useRouter()
    const store = useStore()
    const chartDomRef = ref()
    const obj = reactive({
      searchList: [],
      filteredList: [],
      searchValue: '',
      selectRangeList: [
        {
          value: '3',
          label: '最近 3年'
        },
        {
          value: '5',
          label: '最近 5年'
        },
        {
          value: '10',
          label: '最近 10年'
        }
      ],
      selectedRangeValue: '3',
      legendData: [],
      Xdata: [],
      seriesData: [],
      seriesList: [],

    })

    // 生命周期函数 挂载完毕事件
    onMounted(() => {
      vueEvent.emit('navbarMenuIdxEvent', '10') 
      vueEvent.emit('sidebarMenuIdxEvent', '')
      getQueryInfo()
    })

    // 生命周期函数 挂载销毁事件
    onUnmounted(() => {
      setStore()
    })

    // 获取URL传值
    const getQueryInfo = () => {
      if (route.query.name != null) {
        obj.searchValue = route.query.name
        renderSelect()
        requestData()
      } else {
        renderView()
      }
    }

    // 渲染画面
    const renderView = () => {
      // 是否存在缓存
      if (store.state.historyData === ''){
        // 无缓存，从后台请求数据
        renderSelect()
      } else {
        // 有缓存，设定页面状态
        getStore()
        // 渲染图表
        var myChart = renderChart()
        // 保存缓存(否则chart无法自适应窗口)
        setStore(myChart)
      }
    }

    // 获取数据渲染下拉框
    const renderSelect = () => {
      let formData = new FormData()
      formData.append("category", "main")
      http({
        url: `/contract`,
        method: 'post',
        data: formData
      }).then((res) => {
        // console.log(res.data.data)
        obj.searchList = res.data.data
      })
    }

    // 搜索框输入事件
    const handleInput = () => {
      if (obj.searchValue.trim() === '') {
        obj.filteredList = []
        return
      }
      obj.filteredList = obj.searchList.filter(item => item['name'].toUpperCase().includes(obj.searchValue.trim().toUpperCase()) ||
      item['symbol'].toUpperCase().includes(obj.searchValue.trim().toUpperCase()))
    }

    // 搜索框回车事件
    const handleEnter = () => {
      if (obj.filteredList.length !== 0){
        obj.searchValue = obj.filteredList[0]['name']
        obj.filteredList = []
        requestData()
      }
    }
    
    // 搜索结果点击事件
    const handleClick = (data) => {
      obj.searchValue = data['name']
      obj.filteredList = []
      requestData()
    }

    // 获取数据渲染图表
    const requestData = () => {
      let formData = new FormData()
      formData.append("name", obj.searchValue)
      formData.append("range", obj.selectedRangeValue)
      if (obj.searchValue.trim() !== ''){
        http({
            url: `/history`,
            method: 'post',
            data: formData
        }).then((res) => {
            // console.log(res)
            processData(res)    
            var myChart = renderChart()
            setStore(myChart)
        })
      }
    }
    
    // 加工处理数据
    const processData = (res) => {
      obj.legendData = res.data.data[0]
      obj.Xdata = res.data.data[1]
      obj.seriesData = res.data.data[2]
      // renderChart()
    }

    // 绘制图表
    const renderChart = () => {
      obj.seriesList = []
      // console.log(obj.legendData)
      // console.log(obj.Xdata)
      // console.log(obj.seriesData)
      let i = 0
      obj.seriesData.forEach((item) => {
        if (i == 0){
          // 设置坐标数据
          let data = item.map((item) => item['close'])
          let name = item.map((item) => item['name'])
          obj.seriesList.push({'name': name[0], 
            'type': 'line',
            'data': data,
            'smooth': true,
            'showSymbol': false,
            itemStyle: {
              normal: {
                color: 'black', //改变折线点的颜色
                lineStyle: {
                    color: 'black' //改变折线颜色
                }
              }
            }
          }) 
        }else{
          // 设置坐标数据
          let data = item.map((item) => item['close'])
          let name = item.map((item) => item['name'])
          obj.seriesList.push({'name': name[0], 
            'type': 'line',
            'data': data,
            'smooth': true,
            'showSymbol': false,
          }) 
        }
        i++
      })
      var myChart = setCharts(chartDomRef.value, '', obj.legendData, obj.Xdata, obj.seriesList)
      return myChart
    }
      
    // 保存至store
    const setStore = (myChart) => {
      store.commit('setMyChart', myChart)
      var storeObj = {'searchList':obj.searchList,
                      'searchValue': obj.searchValue,
                      'selectedRangeValue': obj.selectedRangeValue,
                      'legendData': obj.legendData,
                      'Xdata': obj.Xdata,
                      'seriesData': obj.seriesData,
                      'seriesList': obj.seriesList,
                      }
      store.commit('setHistoryData', storeObj) // 缓存数据
    }

    // 获取Store
    const getStore = () => {
      obj.searchList = store.state.historyData.searchList
      obj.searchValue = store.state.historyData.searchValue
      obj.selectedRangeValue = store.state.historyData.selectedRangeValue
      obj.legendData = store.state.historyData.legendData
      obj.Xdata = store.state.historyData.Xdata
      obj.seriesData = store.state.historyData.seriesData
      obj.seriesList = store.state.historyData.seriesList
    }

    // 页面空白点击事件
    const handlePageClick = () => {
      obj.filteredList = []
    }

    // 下拉框选择事件
    const handleSelectChange = () => {
      requestData()
    }

    // 图表刷新
    const handleRefresh = () => {
      store.state.myChart && store.state.myChart.resize() // 图表自适应
      requestData()
    }

    return {
      obj,
      store,
      chartDomRef,
      handleInput,
      handleEnter,
      handleClick,
      handleSelectChange,
      handleRefresh,
      handlePageClick
    }
  }
}
</script>
<style lang="scss" scoped>
/* ================================
Components
Search
================================= */
.search-ul {
  position: absolute;
  left: 80px;
  top: 95px;
  z-index: 600;
  padding: 0;
  margin: 0;
  color: black;
  font-size: 14px;
  background: white;
  border-radius: 3px;
  list-style: none;
  -webkit-box-shadow: 0 3px 8px rgba(31, 31, 31, 0.25),
    0 0 0 0px rgba(31, 31, 31, 0.15);
  box-shadow: 0 3px 8px rgba(31, 31, 31, 0.25), 0 0 0 0px rgba(31, 31, 31, 0.15);
  -webkit-transition: opacity 100ms ease-out;
  transition: opacity 100ms ease-out;
  overflow: auto;
}
.search-li {
  text-align: left;
  border-bottom: 1px solid #e7e7e7;
  cursor: pointer;
  opacity: 0.8;
  height: 40px;
  line-height: 40px;
  padding: 0px 10px;
  border-bottom: 1px solid rgb(238, 238, 238);
}
.search-li:hover {
  background-color: #f5f5f5;
  color: rgb(89, 141, 252);
  border-radius: 3px;
  transition-property: color;
  transition-duration: 0.3s;
  transition-timing-function: ease;
}
</style>
